import React, { Component } from 'react';
import './styles.scss';
import { Link } from 'react-router-dom';
// import { withLocalize } from 'react-localize-redux';
import SearchAutoComplete from '../../search-autocomplete';
import { connect } from 'react-redux';
import { getCookie } from '../../../common/enum';
import {inquiry} from "../constant";

import {
    getNotification,
    getNoticesLatest,
    ACTIONS_NOTIFICATION
} from './../../../actions/notification';

import {
    ACTIONS_SEARCH,
    getSearchCommon
} from './../../../actions/player-search';
class Headers extends Component {

    constructor(props) {
        super(props);
        this.state = {
            langs: localStorage.getItem('SET_LANG'),
            isLogin: localStorage.getItem('ACCESS_TOKEN'),
            showDropdown: false,
            listDropdown: [],
            notification: 0,
            textNotification: ""
        };
        this.navigatePlayer = this.navigatePlayer.bind(this);
        this.interval = null;
    }

    componentDidMount() {
        this.checkNotification();
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    checkNotification = () => {
        this.interval = setInterval(() => {
            this.props.getNotification();
        }, 300000);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if ((localStorage.getItem("ACCESS_TOKEN") || getCookie('ACCESS_TOKEN')) && !this.state.isFirst) {
            this.setState({
                isFirst: true
            })
            this.props.getNotification();
            this.props.getNoticesLatest();
        }
        if (nextProps.status === ACTIONS_SEARCH.GET_PLAYER_SUCCESS) {
            this.setState({
                listDropdown: nextProps.response
            })

        }

        if (nextProps.statusNotification == ACTIONS_NOTIFICATION.GET_NOTIFICATION_SUCCESS) {
            this.setState({
                notification: nextProps.responseNotification.notice
            })
        }

        if (nextProps.statusNotice == ACTIONS_NOTIFICATION.GET_NOTICE_LATEST_SUCCESS) {
            let notice = nextProps.responseNotice;
            if (notice.opened_at && notice.is_unread && notice.content) {
                this.setState({
                    textNotification: notice.opened_at.split(" ")[0] + notice.content.lenght > 10 ? notice.content.slice(0, 10) : notice.content
                })
            } else {
                this.setState({
                    textNotification: ""
                })
            }

        }

        this.setState({
            // langs: next.activeLanguage.code,
            isLogin: localStorage.getItem('TOKEN'),
        });
    }

    // setLang(ev) {
    //   localStorage.setItem('SET_LANG', ev);
    //   this.props.setActiveLanguage(ev);
    // }

    logOut = () => {
        localStorage.removeItem('ACCESS_TOKEN');
        localStorage.removeItem('REFRESH_TOKEN');
        localStorage.removeItem('MEMBER');
        localStorage.removeItem('MENUS');
        document.cookie = `ACCESS_TOKEN=`
        document.cookie = `REFRESH_TOKEN=`
        this.props.history.push('/login');
        this.setState({
            isFirst: false
        })
    }

    navigatePlayer(player) {
        this.props.history.push(window.open(`/player/${player.id}`, '_blank'));
    }

    render() {
        return (
            <div>
                {
                    this.props.location.pathname === '/login'
                        || this.props.location.pathname === '/' ? '' :
                        <nav className="nav" style={this.props.location.pathname === '/detailed-search' ? {position: 'fixed'} : {position: 'relative'}} >
                            <div>
                                <SearchAutoComplete onPlayerClick={this.navigatePlayer} placeholder="検索したい選手名を入力"/>
                            </div>
                            <ul>
                                <li style={{width: 444, justifyContent: 'stretch'}}>
                                    <div className="notification">
                                        <Link to='news'>
                                            <div className="items">
                                                <img src="/img/ic_chuong_svg.svg" alt="" />
                                                {
                                                    this.state.notification > 0 ? <div className="ic_notification">{this.state.notification}</div> : null
                                                }

                                            </div>
                                        </Link>
                                    </div>
                                        <div className="inquiry">
                                            <a href={inquiry.url} target="_blank">
                                                <div className="items">
                                                    <img src={inquiry.img} alt="" />
                                                    <span className={'inquiry_text'}>{inquiry.text}</span>
                                                </div>
                                            </a>
                                        </div>
                                    <div className="logout" style={this.props.location.pathname === '/detailed-search' ? {marginRight: 80} : {}}>
                                        <img src="/img/ic_logout_svg.svg" alt="logout" />
                                        <span onClick={this.logOut} className="text-logout inquiry_text">ログアウト</span>
                                    </div>
                                </li>
                            </ul>
                        </nav >}
            </div>);
    }
}

const mapStateToProps = ({ playerSearch, notification }) => {
    return {
        response: playerSearch.response,
        status: playerSearch.status,
        responseNotification: notification.response,
        statusNotification: notification.status,
        responseNotice: notification.responseNotice,
        statusNotice: notification.statusNotice
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getSearchCommon: (keyword) => {
            dispatch(getSearchCommon(keyword));
        },
        getNotification: () => {
            dispatch(getNotification())
        },
        getNoticesLatest: () => {
            dispatch(getNoticesLatest())
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps, null, { pure: false })(Headers);
